import css from "./PriceMvaInfo.module.scss"
import { PuxTypography } from "@phonero/pux-react"
import React, { FC } from "react"
const PriceMvaInfo: FC = () => (
  <div className={css.mvaInfoContainer}>
    <PuxTypography variant={"info-small"} component={"label"}>
      Alle priser er oppgitt ekskl. mva.
    </PuxTypography>
  </div>
)
export default PriceMvaInfo
